export default __webpack_public_path__ + "static/media/안주6.f7e70455.jpg";